import { jsx as _jsx } from "react/jsx-runtime";
import { Sync } from 'seagull/icons';
import { AccountingSyncIcon } from '~/integrations/Accounting/AccountingIcon/AccountingSyncIcon';
import { ReconciledIcon } from '~/integrations/Accounting/ReconciledIcon';
import { Accounting } from '~/types/api.model';
export const qboIconMap = {
    pending: /*#__PURE__*/ _jsx(AccountingSyncIcon, {
        intent: "pending",
        prefix: "qbo"
    }),
    error: /*#__PURE__*/ _jsx(AccountingSyncIcon, {
        intent: "error",
        prefix: "qbo"
    }),
    success: /*#__PURE__*/ _jsx(AccountingSyncIcon, {
        intent: "success",
        prefix: "qbo"
    }),
    syncing: /*#__PURE__*/ _jsx(Sync, {
        testId: "qbo-in-progress"
    }),
    done: /*#__PURE__*/ _jsx(ReconciledIcon, {})
};
export const xeroIconMap = {
    pending: /*#__PURE__*/ _jsx(AccountingSyncIcon, {
        intent: "pending",
        prefix: "xero"
    }),
    error: /*#__PURE__*/ _jsx(AccountingSyncIcon, {
        intent: "error",
        prefix: "xero"
    }),
    success: /*#__PURE__*/ _jsx(AccountingSyncIcon, {
        intent: "success",
        prefix: "xero"
    }),
    syncing: /*#__PURE__*/ _jsx(Sync, {}),
    done: /*#__PURE__*/ _jsx(ReconciledIcon, {})
};
export const accountingIconMap = {
    [Accounting.QBO]: qboIconMap,
    [Accounting.Xero]: xeroIconMap
};
